import React, { Component } from 'react'
import styled from 'styled-components'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'

import scrollOnMount from 'utils/scrollOnMount'
import withPost from 'containers/withPost'
import withSiteMeta from 'containers/withSiteMeta'
import Modules from 'ui/components/Modules'
import Seo from 'ui/components/Seo'
import NotFound from 'ui/components/NotFound'

const Wrapper = styled.div`
  min-height: calc(100vh - 396px);
`;

const LoaderContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
height: 100vh;
`

const Loader = styled.div`
width: 50px;
height: 50px;
border: 5px solid #0040774f;
border-bottom-color: #004077;
border-radius: 50%;
display: inline-block;
box-sizing: border-box;
animation: rotation 1s linear infinite;

@keyframes rotation {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
`


class Page extends Component {
  state = {
    loaded: false
  }

  componentDidUpdate() {
    //Check if page is a draft and redirect to the main page
    //Also set the state that prevents Modules from loading on a draft
    //Eliminates a delay between load and the redirect
    if (this.props.post && this.state.loaded == false) {
      if (this.props.post.status !== 'draft') {
        this.setState({ loaded: true })
      } else {
        window.location.replace('http://www.dol-sensors.com')
      }
    }
  }


  render() {
    const { post, loading, type } = this.props
    const { loaded } = this.state

    return (
      <Wrapper>
        {!loading &&
          <div>
            <Seo seo={post.seo} />
          </div>
        }
        {!loaded &&
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        } 
        {post && post.modules && 
          <Modules modules={post.modules} post={post} type={type} />
        }
      </Wrapper>
    );
  }
}

export default compose(
  scrollOnMount,
  withSiteMeta(),
  withRouter,
  withPost(props => (props.match.params.parent ? `${props.match.params.parent}/${props.match.params.slug}` : props.match.params.slug) || props.siteMeta.frontPageSlug, props => props.type, undefined, () => <NotFound />)
)(Page)



// WEBPACK FOOTER //
// ./src/ui/components/Page.js